import React, { useState } from 'react';
import css from './ImgGallery.module.css';
import BrandIconCard from '../../components/BrandIconCard/BrandIconCard';
import Slider from 'react-slick';

export default function ImgGallery({ data }) {
  const limitData = data?.slice(0, 5);

  // show all images in popup
  const [allGalleryPopup, setAllGalleryPopup] = useState(false);

  // carousel slider for particular image
  const [carouselPopup, setCarouselPopup] = useState(false);

  // active index for carousel
  const [activeIndex, setActiveIndex] = useState(0);

  const openGalleryPopup = () => {
    setAllGalleryPopup(true);
  };

  const closeGalleryPopup = () => {
    setAllGalleryPopup(false);
  };

  const openCarouselPopup = index => {
    setAllGalleryPopup(false);
    setActiveIndex(index);
    setCarouselPopup(true);
  };

  const closeCarouselPopup = () => {
    setCarouselPopup(false);
  };

  return (
    <>
      {/* show all image in grid view */}
      <div className={css.mainImgGridWrapper}>
        {limitData?.map((i, index) => (
          <div key={index} className={css.imgContainer}>
            <img
              onClick={openGalleryPopup}
              src={i?.attributes?.variants?.facebook?.url}
              alt="img"
            />
          </div>
        ))}

        <button onClick={openGalleryPopup} className={css.showAllBtn}>
          <BrandIconCard type="smallDots" />
          <span>Show All</span>
        </button>
      </div>

      {/* show all image in popup */}
      {allGalleryPopup && (
        <AllGalleryImg img={data} closeBtn={closeGalleryPopup} openCarousel={openCarouselPopup} />
      )}

      {/* show particular image click on */}
      {carouselPopup && (
        <CarouselPopup activeIndex={activeIndex} img={data} closeBtn={closeCarouselPopup} />
      )}
    </>
  );
}

const AllGalleryImg = ({ img, closeBtn, openCarousel }) => {
  console.log(img);

  return (
    <div className={css.popupModalAllImg}>
      <div className={css.contentBody}>
        <div className={css.imgsWrapper}>
          {img?.map((i, index) => (
            <div onClick={() => openCarousel(index)} key={index} className={css.imgContainer}>
              <img src={i?.attributes?.variants?.facebook?.url} alt="img" />
            </div>
          ))}
        </div>
        <span onClick={closeBtn} className={css.closeBtn}>
          <BrandIconCard type="close" />
        </span>
      </div>
    </div>
  );
};

const CarouselPopup = ({ img, closeBtn, activeIndex }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: activeIndex,
  };

  return (
    <div className={css.popupModalAllImg}>
      <div className={css.carouselWrapper}>
        <Slider {...settings}>
          {img?.map((i, index) => (
            <div key={index} className={css.carouselImg}>
              <img src={i?.attributes?.variants?.facebook?.url} alt={`img-${index}`} />
            </div>
          ))}
        </Slider>

        <span onClick={closeBtn} className={css.closeBtn}>
          <BrandIconCard type="close" />
        </span>
      </div>
    </div>
  );
};
